// src/components/strumenti/CampoVisivoTVCC.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

// Larghezza/altezza sensore in mm per i formati ottici più comuni in TVCC
const SENSORI = {
  "1/3\"":   { w:4.8,  h:3.6 },
  "1/2.8\"": { w:5.14, h:3.86 },
  "1/2.7\"": { w:5.37, h:4.04 },
  "1/2\"":   { w:6.4,  h:4.8 },
  "1/1.8\"": { w:7.18, h:5.32 },
};

export default function CampoVisivoTVCC() {
  const [sensore, setSensore] = useState("1/2.8\"");
  const [focale, setFocale] = useState("");
  const [distanza, setDistanza] = useState("");

  const f = leggiNumero(focale)||0;
  const s = SENSORI[sensore];
  const fovOrizz = f>0 ? 2 * Math.atan(s.w/(2*f)) * (180/Math.PI) : null;
  const fovVert = f>0 ? 2 * Math.atan(s.h/(2*f)) * (180/Math.PI) : null;

  const d = leggiNumero(distanza)||0;
  const larghezzaInquadrata = (f>0 && d>0) ? (s.w/f)*d : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Formato sensore</label>
          <select value={sensore} onChange={e=>setSensore(e.target.value)} style={inp}>
            {Object.keys(SENSORI).map(k => <option key={k} value={k}>{k}</option>)}
          </select>
        </div>
        <div>
          <label style={lbl}>Lunghezza focale (mm)</label>
          <input value={focale} onChange={e=>setFocale(e.target.value)} style={inp} placeholder="Es. 2.8"/>
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Distanza dalla scena (m) — facoltativo, per la larghezza inquadrata</label>
        <input value={distanza} onChange={e=>setDistanza(e.target.value)} style={inp} placeholder="Es. 10"/>
      </div>

      <div style={{ background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around", marginBottom: larghezzaInquadrata!==null ? 10 : 0 }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Campo visivo orizz.</div>
            <div style={{ fontSize:20, fontWeight:800, color:"#6d28d9" }}>{fovOrizz!==null ? `${fovOrizz.toFixed(1)}°` : "—"}</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Campo visivo vert.</div>
            <div style={{ fontSize:20, fontWeight:800, color:"#6d28d9" }}>{fovVert!==null ? `${fovVert.toFixed(1)}°` : "—"}</div>
          </div>
        </div>
        {larghezzaInquadrata!==null && (
          <div style={{ textAlign:"center", borderTop:"1px solid #ddd6fe", paddingTop:10 }}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Larghezza inquadrata a {distanza}m</div>
            <div style={{ fontSize:18, fontWeight:800, color:"#6d28d9" }}>≈ {larghezzaInquadrata.toLocaleString("it-IT",{maximumFractionDigits:1})} m</div>
          </div>
        )}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Calcolo geometrico indicativo — non tiene conto di distorsioni ottiche reali della lente.
      </div>

      <button onClick={()=>{setFocale("");setDistanza("");setSensore("1/2.8\"");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
